export enum AppointmentAttendanceState {
  ATTENDED = 'attended',
  CANCELLED = 'cancelled',
  CONFIRMED = 'confirmed',
  NO_SHOW = 'no_show',
  NOT_RECORDED = 'not_recorded',
  PENDING = 'pending',
  PENDING_ATTENDANCE = 'pending_attendance',
  RESCHEDULED = 'rescheduled'
}

export const appointmentAttendanceStateLabels: Record<AppointmentAttendanceState, string> = {
  [AppointmentAttendanceState.ATTENDED]: 'Attended',
  [AppointmentAttendanceState.CANCELLED]: 'Cancelled',
  [AppointmentAttendanceState.CONFIRMED]: 'Confirmed',
  [AppointmentAttendanceState.NO_SHOW]: 'No Show',
  [AppointmentAttendanceState.NOT_RECORDED]: 'Not Recorded',
  [AppointmentAttendanceState.PENDING]: 'Pending',
  [AppointmentAttendanceState.PENDING_ATTENDANCE]: 'Pending Attendance',
  [AppointmentAttendanceState.RESCHEDULED]: 'Rescheduled'
};

export const defaultUpcomingAppointmentAttendanceStates: AppointmentAttendanceState[] = [
  AppointmentAttendanceState.ATTENDED,
  AppointmentAttendanceState.CONFIRMED,
  AppointmentAttendanceState.NO_SHOW,
  AppointmentAttendanceState.PENDING,
  AppointmentAttendanceState.PENDING_ATTENDANCE
];
